import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase.init';
import useUser from '../../hooks/useUser';
import Navbar from '../Shared/Navbar';
import { BsFillBookmarkCheckFill, BsFillBookmarkStarFill } from 'react-icons/bs';
import { MdReviews } from 'react-icons/md';
import { Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import axios from 'axios';

const EditProfile = () => {
    const [user, loading] = useAuthState(auth);
    const [userc] = useUser(user?.email);
    let navigate = useNavigate();

    const handleUpdateUser = async (updatedUser) => {
        await axios.put("https://tripaide-server.onrender.com/users", updatedUser)
            .then(res => {
                //console.log(res.data);
                if (res.data.acknowledged) {
                    toast.success("Profile is updated.");
                    navigate(`/u/${userc?._id}`);
                } else {
                    toast.error("Something went wrong.")
                }
            });
    };

    const handleUpdateProfile = (e) => {
        e.preventDefault();
        const updatedData = {
            name: e.target.name.value,
            email: e.target.email.value,
            img: e.target.img.value,
            phone: e.target.phone.value,
            speaks: e.target.speaks.value,
            city: e.target.city.value,
            division: e.target.division.value,
            pcode: e.target.pcode.value,
            bio: e.target.bio.value
        };

        //console.log(updatedData);

        handleUpdateUser(updatedData);
    }

    return (
        <div className="container">
            <Navbar />
            <div className="row">
                {
                    loading ? (
                        <h1 className='min-h-screen text-4xl my-8 text-yellow-500'>Loading...</h1>
                    ) : (
                        <div className='w-11/12 mx-auto min-h-screen py-16'>
                            <div className='lg:flex'>
                                <div className='w-11/12 lg:w-1/3 p-4'>
                                    <img className='w-1/2 block rounded-lg' src={userc?.img} alt="profile picture" />
                                    <h2 className='mt-5 mb-12 text-2xl font-extrabold'>{userc?.name}</h2>
                                    {
                                        userc?.noRating == 0 ? (
                                            <div className='flex items-center justify-center md:justify-start mt-2 mb-4'>
                                                <BsFillBookmarkStarFill className='text-yellow-500' />
                                                <p className='font-semibold px-1 capitalize'>New {userc?.role}</p>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className='flex items-center justify-start mt-2 mb-4'>
                                                    <BsFillBookmarkStarFill className='text-yellow-500' />
                                                    <p className='font-semibold px-1'>{userc?.rating}</p>
                                                    <MdReviews className='ml-8 text-yellow-500' />
                                                    <p className='font-medium px-1'>{userc?.noRating}+ reviews</p>
                                                </div>
                                                <div className='flex items-center justify-start mt-2 mb-4'>
                                                    <BsFillBookmarkCheckFill className='text-yellow-500' />
                                                    <p className='font-semibold px-1 capitalize'>{userc?.noTour}  Tours  Completed</p>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                <form onSubmit={handleUpdateProfile} className='w-11/12 lg:w-2/3 p-12 shadow-2xl rounded-2xl '>
                                    <div required className='mb-8'>
                                        <h2 className='text-xl text-gray-500 font-bold'>Edit Name</h2>
                                        <input required className='border-2 rounded-lg px-4 py-2 my-2 block w-2/3' type="text" name="name" id="name" defaultValue={userc?.name} />
                                    </div>
                                    <div className='mb-8'>
                                        <h2 className='text-xl text-gray-500 font-bold'>Edit Img URL</h2>
                                        <input required className='border-2 rounded-lg px-4 py-2 my-2 block w-2/3' type="url" name="img" id="img" defaultValue={userc?.img} />
                                    </div>
                                    <div className='mb-8'>
                                        <h2 className='text-xl text-gray-500 font-bold'>Email Address</h2>
                                        <input disabled className='border-2 rounded-lg px-4 py-2 my-2 block w-2/3' type="text" name="email" id="email" defaultValue={userc?.email} />
                                    </div>
                                    <div className='mb-8'>
                                        <h2 className='text-xl text-gray-500 font-bold'>Edit Phone Number</h2>
                                        <input className='border-2 rounded-lg px-4 py-2 my-2 block w-2/3' type="number" name="phone" id="phone" defaultValue={userc?.phone} />
                                    </div>
                                    <div className='mb-8'>
                                        <h2 className='text-xl text-gray-500 font-bold'>Edit Language</h2>
                                        <input className='border-2 rounded-lg px-4 py-2 my-2 block w-2/3' type="text" name="speaks" id="speaks" defaultValue={userc?.speaks} />
                                    </div>
                                    <div className='md:flex'>
                                        <div className='mb-8 w-full'>
                                            <h2 className='text-xl text-gray-500 font-bold'>Edit Postal Code</h2>
                                            <input required className='border-2 rounded-lg px-4 py-2 my-2 block w-1/3 md:w-1/2' type="text" name="pcode" id="pcode" defaultValue={userc?.pcode} />
                                        </div>
                                        <div className='mb-8 w-full'>
                                            <h2 className='text-xl text-gray-500 font-bold'>Edit City</h2>
                                            <input required className='border-2 rounded-lg px-4 py-2 my-2 block w-2/3' type="text" name="city" id="city" defaultValue={userc?.city} />
                                        </div>
                                    </div>
                                    <div className='mb-8'>
                                        <h2 className='text-xl text-gray-500 font-bold'>Edit Division</h2>
                                        <input required className='border-2 rounded-lg px-4 py-2 my-2 block w-2/3' type="text" name="division" id="division" defaultValue={userc?.division} />
                                    </div>
                                    <div className='mb-8'>
                                        <h2 className='text-xl text-gray-500 font-bold'>Edit Bio</h2>
                                        <textarea rows="5" className='border-2 rounded-lg px-4 py-2 my-2 block w-full' type="text" name="bio" id="bio" defaultValue={userc?.bio} />
                                    </div>
                                    <Button type='submit' className='bg-yellow-500 text-lg font-medium' variant="contained">Update</Button>
                                </form>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default EditProfile;